import { render, staticRenderFns } from "./billing-info-v2.component.vue?vue&type=template&id=613e05b1&scoped=true&"
import script from "./billing-info-v2.component.vue?vue&type=script&lang=ts&"
export * from "./billing-info-v2.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-info-v2.component.vue?vue&type=style&index=0&id=613e05b1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e05b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
